
<v-row justify="center">
  <v-col v-for="(person, index) in persons" cols="auto" @click="onSelect(index)">
    <v-sheet elevation="5" rounded class="personContainer">
      <div class="imageContainer"
           :style="{backgroundImage: 'url(' + getImageUrl(getPersonPreviewImage(person).smallUrl) + ')'}"></div>
      <div class="codeContainer">
        <p class="code">{{ person.code }}</p>
      </div>
    </v-sheet>
  </v-col>
</v-row>
